
import { snakizeObject } from '@cvt/helpers/object';


export const mapFeedbackCrudData = (data: Feedback.Crud | Feedback.Create): Feedback.FeedbackApi => {
  const apiData: Feedback.FeedbackApi = snakizeObject(data);
  return {
    ...apiData,
  };
};
